import { useState,useRef} from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import RouteConstant from "../../constants/route.constants";
import { useTranslation } from "react-i18next";
import UserAddressService from "../../services/useraddress/useraddress.service";
import { Toast, ToastMessage } from "primereact/toast";

const AddressSelector = (props: any) => {
   const toast = useRef<Toast>(null);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deletableAddressId, setDeletableAddressId] = useState<number>(0);
  const { t } = useTranslation();
  var navigate = useNavigate();

  const showMessage = (label: string, message: string, severity: ToastMessage['severity']) => {
          toast.current?.show({ severity: severity, summary: label, detail: message, life: 3000 });
      }

  const footerContent = (
    <div className="button-container ">
      <Button
        label="Cancel"
        onClick={() => setVisible(false)}
        className="border-1 bg-white text-900"
      />
      <Button
        label="Ok"
        onClick={() => deleteAddressFromData()}
        className=" bg-red-600 w-2"
      />
    </div>
  );

  // const editAddress = (addressId: number) => {
  //   navigate(RouteConstant.editaddresss + addressId);
  // };
  const editAddress = async (addressId: number) => {
    try {
      setLoading(true);
      const canEditResponse = await UserAddressService.canEditAddress(addressId);
     
      if (!canEditResponse.isSuccess && canEditResponse.message.includes("active orders")) {
        showMessage("Error", canEditResponse.message, "error");
        setTimeout(() => navigate(RouteConstant.userAddresses), 2000);
        return;
      }
     
      navigate(RouteConstant.editaddresss + addressId);
    } catch (error) {
      showMessage("Error", "Failed to load address", "error");
      navigate(RouteConstant.userAddresses);
    } finally {
      setLoading(false);
    }
  };

  const editAddressArea = (addressId: number) => {
    navigate(RouteConstant.editaddresss + addressId);
  };

  const deleteAddress = (addressId: number) => {
    setDeletableAddressId(addressId);
    setVisible(true);
  };

  // const deleteAddressFromData = async () => {
  //   await UserAddressService.deleteUserAddress(deletableAddressId);
  //   props.getAddreses();
  //   setVisible(false);
  // };

  const deleteAddressFromData = async () => {
   
    try {
      const response = await UserAddressService.deleteUserAddress(deletableAddressId);
     
      if (response?.isSuccess) {
        showMessage("Success", response.message, "success");
        props.getAddreses();
        setVisible(false);
      } else {
        showMessage("Error", response?.message ,"error");
      }
    } catch (error) {
      showMessage("Error", "An unexpected error occurred.", "error");
    }
  };
  return (
    <>
    
      <div className="address-box">
        <div className="flex">
          <RadioButton
            inputId={props.id}
            name={props.name}
            value={props.id}
            onChange={(e) => props.addressSelect(e.value)}
            checked={props.selectedId === props.id}
            className="mt-1"
          />
          <label className="ml-2"> 
       
            <p className="mb-0">
        
              <b>{props.addressLine1}</b> {props.addressLine2} {props.landmark}{" "}
              {props.areaName} {props.city} {props.state} {props.country} Pin-{props.pincode}
             
            </p>
           
            
            {/* <b>{props.addressLine1}</b> {props.addressLine2} {props.landmark}{" "}
              {props.city} {props.state} Pin-{props.pincode}
              </p> */}
            <span
              className="edit-address"
              onClick={(e: any) => {
                if (props.areaID) {
                  editAddressArea(props.id);
                } else {
                editAddress(props.id);
              }}}
            >
              {t("editaddress_edit_address")}
            </span>{" "}
            |
            <span
              className="delete-address"
              onClick={(e: any) => {
                deleteAddress(props.id);
              }}
            >
              {t("useraddress_delete_address")}
            </span>
          </label>
        </div>
      </div>

      <Dialog
        header="Delete Address"
        visible={visible}
        style={{ width: "45vw" }}
        onHide={() => setVisible(false)}
        footer={footerContent}
        className="dialog-delete-add"
      >
        <p className="m-0">{t("useraddress_delete_confirmmessage")}</p>
      </Dialog>
      <Toast ref={toast} position="top-right" />
    </>
  );
};

export default AddressSelector;
